import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';

interface WrapperPropsType {
  variant?: DefaultComponentVariantType | null;
}

const setWrapper = (variant: DefaultComponentVariantType | null = null, theme: EmotionTheme): SerializedStyles => {
  if (variant === DefaultComponentVariantType.TERTIARY) {
    return css`
        background-color: ${theme.star.unified.layoutGlobal.bgColor};
        height: 100%;
        display: flex;
        flex-flow: column;

        & .sport-general {
            height: stretch;
            display: flex;
            flex-flow: column;
        }
    `
  }

  return css`
      background-color: ${theme.star.layoutGlobal.bgColor};
  `
}

export const Wrapper = withConfig(theme => styled('div', { label: 'Wrapper' })<WrapperPropsType>`
    ${({ variant }) => setWrapper(variant, theme)}
`);

export const SectionWrapper = styled('div', { label: 'SectionWrapper' })`
    display: flex;
    flex-flow: column nowrap;
    flex: 1 1 0%;
`;
